<div id="relatorio-guias" class="container-fluid">
  <h3 *ngIf="isMobile===false">Contagens de Inventário</h3>
  <mat-card>
      <mat-card-header class="header-padrao">
          <mat-card-title>
              <form id="formContagem" class="filtros-header" [formGroup]="inventarioContagemForm"
                  (keyDown)="enter($event)">
                  <div class="header-filter-log">
                      <div class="row" style="display: inherit;">

                          <div class="row">

                              <mat-form-field class="align-center" *ngIf="isMobile===true">
                                  <mat-label>Inventariante </mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="inventariante">
                              </mat-form-field>


                              <mat-form-field class="width-80" *ngIf="isMobile === true">
                                  <mat-label>Número </mat-label>
                                  <input matInput class="number" type="text" [disableControl]="true"
                                      formControlName="inventarioId">
                              </mat-form-field>

                              <mat-form-field class="width-80" *ngIf="isMobile === true">
                                  <mat-label>Contagem </mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="numeroContagem">
                              </mat-form-field>


                              <mat-form-field class="example-full-width" *ngIf="isMobile === false">
                                  <mat-label>Número </mat-label>
                                  <input matInput class="number" type="text" [disableControl]="true"
                                      formControlName="inventarioId">
                              </mat-form-field>

                              <mat-form-field class="example-full-width" *ngIf="isMobile === false">
                                  <mat-label>Contagem </mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="numeroContagem">
                              </mat-form-field>

                              <mat-form-field class="example-full-width" *ngIf="isMobile === false">
                                  <mat-label>Agente </mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="agente">
                              </mat-form-field>
                          </div>

                          <div class="row">
                              <mat-form-field *ngIf="isMobile === false">
                                  <mat-label>Data Criação</mat-label>
                                  <input matInput autocomplete="off" [matDatepicker]="dataFinal" [disableControl]="true"
                                      formControlName="dtCriacao">
                                  <mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
                                  <mat-datepicker #dataFinal></mat-datepicker>
                              </mat-form-field>

                              <mat-form-field class="example-full-width" *ngIf="isMobile === false">
                                  <mat-label>Criado Por </mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="criadoPor">
                              </mat-form-field>

                              <mat-form-field class="example-full-width" *ngIf="isMobile===false">
                                  <mat-label>Inventariante </mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="inventariante">
                              </mat-form-field>


                              <!-- <mat-form-field class="width-80" *ngIf="isMobile === true">
                                  <mat-label>Total NRT </mat-label>
                                  <input matInput class="number" type="text" [disabled]="true"
                                      formControlName="totalNRT">
                              </mat-form-field>

                              <mat-form-field class="width-80" *ngIf="isMobile === true">
                                  <mat-label>Total Volume </mat-label>
                                  <input matInput type="text" [disabled]="true" formControlName="totalVolume">
                              </mat-form-field>
                               -->
                              <!-- <mat-form-field class="align-center" *ngIf="isMobile===true">
                                  <mat-label>Inventariante </mat-label>
                                  <input matInput type="text" [disabled]="true" formControlName="inventariante">
                              </mat-form-field>

                               -->
                              <mat-form-field class="width-80" *ngIf="isMobile === true">
                                  <mat-label>Total NRT </mat-label>
                                  <input matInput class="number" type="text" [disableControl]="true"
                                      formControlName="totalNRT">
                              </mat-form-field>

                              <mat-form-field class="width-80" *ngIf="isMobile === true">
                                  <mat-label>Total Volume</mat-label>
                                  <input matInput type="text" [disableControl]="true" formControlName="totalVolume">
                              </mat-form-field>

                          </div>
                      </div>
                  </div>
              </form>
          </mat-card-title>
          <div style="display: block">
              <button class="voltar" *ngIf="isMobile === false" mat-raised-button color="primary" matTooltip="Voltar"
                  (click)="voltar()">
                  <i class="fas fa-arrow-circle-left"></i> Voltar
              </button>
              <button mat-icon-button class="notification-add-button cursor-pointer-icon"
                  (click)="initLastContagemItens();" *ngIf="isMobile === false" matTooltip="Atualizar contagens">
                  <mat-icon fontSet="fas" fontIcon="fa-undo"></mat-icon>
              </button>
          </div>
      </mat-card-header>

      <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
      <mat-card-content>
          <div>
              <form [formGroup]="inventarioContagemForm">
                  <mat-form-field class="pedidoDocumento">
                      <mat-label>{{isMobile ? 'Código de barras' : 'Digite ou efetue a leitura do pedido
                          através do seu código de barras'}}
                      </mat-label>
                      <input class="" matInput type="text" (keyup)="onChangeEvent()" pattern=".*\S.*"
                          #pedidoIdOrDocumento formControlName="pedidoIdOrDocumento" maxlength="30" minlength="3">
                  </mat-form-field>


                  <span *ngIf="error.message && isMobile" class="error-color" matTooltip="error.message">
                      {{ error.message.length > 80 ? error.message.substring(0, 80) + '...' : error.message }}
                  </span>

                  <br *ngIf="error.message && isMobile">

                  <button id="okButton" mat-raised-button color="primary" matTooltip="Contar"
                      [disabled]="shouldDisable || !inventarioContagemForm.valid || !inventarioContagemForm.get('pedidoIdOrDocumento').value"
                      (click)="buscaCodigoDeBarra()">
                      OK
                  </button>

                  <br *ngIf="error.message && isMobile === false">
                  <span *ngIf="error.message && isMobile === false" class="error-color">
                      {{error.message}}
                  </span>

              </form>
          </div>

          <div>
              <div>
                  <div>
                      <span class="float-right ml-8" *ngIf="isMobile === false">
                          Total NRT: {{totalNRT}}
                      </span>
                      <span class="float-right" *ngIf="isMobile === false">
                          Total Volume: {{totalVolume}}
                      </span>
                  </div>

                  <!--
                  <span class="float-center" *ngIf="isMobile === true">
                      <b>Total NRT {{totalNRT}}</b>
                      <b>Total Volume {{totalVolume}}</b>
                  </span> -->
                  <table id="relatorios" mat-table [dataSource]="collection" class="table-sm">
                      <ng-container matColumnDef="dataCriacao">
                          <th mat-header-cell *matHeaderCellDef class="text-center">Data Criação</th>
                          <td mat-cell *matCellDef="let item" class="text-center">
                              {{ item.dtCriacao | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                      </ng-container>

                      <ng-container matColumnDef="pedidoId">
                          <th mat-header-cell *matHeaderCellDef class="text-center">NRT</th>
                          <td mat-cell *matCellDef="let item" class="text-center">
                              {{ item.pedidoId }}</td>
                      </ng-container>

                      <ng-container matColumnDef="barcode">
                          <th mat-header-cell *matHeaderCellDef class="text-center">Cód. Volume</th>
                          <td mat-cell *matCellDef="let item" class="text-center">
                              {{ item.barcode }}</td>
                      </ng-container>

                      <ng-container matColumnDef="etiqueta" *ngIf="isMobile === false">
                          <th mat-header-cell *matHeaderCellDef class="text-center">Etiqueta</th>
                          <td mat-cell *matCellDef="let item" class="text-center">
                              {{ item.etiqueta }}</td>
                      </ng-container>

                      <ng-container matColumnDef="cliente" *ngIf="isMobile === false">
                          <th mat-header-cell *matHeaderCellDef class="text-center">Cliente</th>
                          <td mat-cell *matCellDef="let item" class="text-center">
                              {{ item.cliente }}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                  <div *ngIf="!isLoading && collection?.data?.length === 0"
                      class="d-flex justify-content-center align-items-center" style="height: 100px;">
                      Nenhum registro foi encontrado!
                  </div>
                  <mat-paginator [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
                      (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 15]"></mat-paginator>
              </div>

          </div>
      </mat-card-content>
  </mat-card>
</div>
